import apiClient from './apiClient';
import { GET_CUISINES } from '../constants/UriConstants';
import { CuisineInterface } from '../types/CuisineInterface';

// eslint-disable-next-line import/prefer-default-export
export const getCuisines = (): Promise<CuisineInterface[]> =>
  apiClient.get(GET_CUISINES).then((response) => response.data);
